const CAVIAR_GRAPH_URL = "https://api-core.caviarnine.com/v1.0/graph";

export const CHART_RANGE_OPTIONS = [
  {
    id: "1D",
    label: "1D",
    lookbackDays: 1,
    sample: "10T",
  },
  {
    id: "1W",
    label: "1W",
    lookbackDays: 7,
    sample: "1H",
  },
  {
    id: "1M",
    label: "1M",
    lookbackDays: 30,
    sample: "4H",
  },
  {
    id: "3M",
    label: "3M",
    lookbackDays: 90,
    sample: "1D",
  },
];

const getRangeOption = (rangeId) =>
  CHART_RANGE_OPTIONS.find((option) => option.id === rangeId) || CHART_RANGE_OPTIONS[1];

export const fetchSwapExplorerChartSeries = async (
  leftResourceAddress,
  rightResourceAddress,
  rangeId
) => {
  const range = getRangeOption(rangeId);
  const endDate = new Date();
  const startDate = new Date(
    endDate.getTime() - range.lookbackDays * 24 * 60 * 60 * 1000
  );

  const params = new URLSearchParams({
    left_resource_address: leftResourceAddress,
    right_resource_address: rightResourceAddress,
    start_dt: startDate.toISOString().slice(0, -1),
    end_dt: endDate.toISOString().slice(0, -1),
    sample: range.sample,
  });

  const response = await fetch(`${CAVIAR_GRAPH_URL}?${params.toString()}`);
  if (!response.ok) {
    throw new Error(`Chart request failed (${response.status})`);
  }

  const payload = await response.json();
  const bars = payload?.data?.ohlc_bars || [];

  return {
    decimalPlaces: payload?.data?.decimal_places ?? 5,
    noData: Boolean(payload?.data?.no_data),
    range,
    points: bars.map(([open, high, low, close, timestamp]) => ({
      timestamp: timestamp * 1000,
      open,
      high,
      low,
      close,
    })),
  };
};
